import ExcelJS from "exceljs";
import { useTripStore } from "../../store/useTripStore";
import { formatDateTimeWithoutSec, getCurrentDateTime1 } from "../../../../../Common/helper/helpar";

export const ExportZoneWiseSATsReport = () => {
  const {
    zoneWiseTrips,
  } = useTripStore();
  
  const downloadExcel = async () => {
    const { FromDateTime, ToDateTime } = JSON.parse(localStorage.getItem("sat-trips-zone-filters")) || {};
    // console.log(formattedTime)
    // Get current date/time for header
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}/${currentDate.getMonth() + 1}/${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const filterDateRange =
      FromDateTime && ToDateTime ? `(${formatDateTimeWithoutSec(FromDateTime)} to ${formatDateTimeWithoutSec(ToDateTime)}) (at ${getCurrentDateTime1()})` : "";
    // Determine report type based on the "circle" flag
    const reportTitle = `Zone Wise SATs Reports To TS/SCTP as on ${filterDateRange}`;
    const generatedText = `Report Generated on: ${formattedDate}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zone");

    const boldFont = { bold: true };
    const centerAlignment = { horizontal: "center", vertical: "middle", wrapText: true };

    // --- Header Row 1: Report Title ---
    const headerRow1 = worksheet.addRow([generatedText]);
    // Merge cells across 10 columns (adjust if needed)
    worksheet.mergeCells(headerRow1.number, 1, headerRow1.number, 10);
    headerRow1.getCell(1).font = boldFont;
    headerRow1.getCell(1).alignment = centerAlignment;

    // --- Header Row 2: Generated Date/Time ---
    const headerRow2 = worksheet.addRow([reportTitle,]);
    worksheet.mergeCells(headerRow2.number, 1, headerRow2.number, 10);
    headerRow2.getCell(1).font = boldFont;
    headerRow2.getCell(1).alignment = centerAlignment;

    // --- Table Header Row ---
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Zone",
      "Reported At TS/SCTP",
      "Total Trips",
      "1 Trip",
      "2 Trip",
      "3 Trip",
      "Above 4 Trips",
      "Quantity in MT(Est)",
    ]);
    tableHeaderRow.eachCell((cell) => {
      cell.font = boldFont;
      cell.alignment = centerAlignment;
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "F6B1B1" },
      };
    });

    // --- Data Rows ---
    zoneWiseTrips.forEach((item, index) => {
      const row = worksheet.addRow([
        index + 1,
        item.zoneName?? "N/A",
        item.reportedatTSSCTP?? "N/A",
        item.totalTrips?? "N/A",
        item.oneTrip?? "N/A",
        item.twoTrips?? "N/A",
        item.threeTrips?? "N/A",
        item.above4Trips?? "N/A",
        item.quantityinMTEst?? "N/A",
      ]);
      row.eachCell((cell) => {
        cell.alignment = centerAlignment;
      });
    });

    // --- Adjust Column Widths ---
    worksheet.columns = [
      { width: 10 },  // S.No
      { width: 20 },  // Zone
      { width: 25 },  // Reported At TS/SCTP
      { width: 15 },  // Total Trips
      { width: 10 },  // 1 Trip
      { width: 10 },  // 2 Trip
      { width: 10 },  // 3 Trip
      { width: 15 },  // Above 4 Trips
      { width: 20 },  // Quantity in MT(Est)
    ];

    // --- Save and Download Workbook ---
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "ZoneWiseSATsReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };
  return (
    <button
      type="reset"
      className="btn btn-excel"
      onClick={downloadExcel}
    >
      <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
    </button>
  )
}